import { render, staticRenderFns } from "./DashboardSoftwareWorkflow.vue?vue&type=template&id=41c51b38&"
import script from "./DashboardSoftwareWorkflow.vue?vue&type=script&lang=js&"
export * from "./DashboardSoftwareWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports